import { render } from "./dependent-joined-waitlist.vue?vue&type=template&id=74a4bf52&scoped=true"
const script = {}

import "./dependent-joined-waitlist.vue?vue&type=style&index=0&id=74a4bf52&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a4bf52"]])

export default __exports__